/* eslint-disable no-unused-vars */
import React, { Fragment, useCallback, useState, useEffect } from 'react';
import 'antd/dist/antd.min.css';
import './style.css';
import './Application.scss';
// eslint-disable-next-line no-unused-vars
import { createBrowserHistory, Path } from 'history';
import Footer from '../../../../Layout/Footer';
// eslint-disable-next-line no-unused-vars
import { RegisterHeader } from '../../Components/Index';
import { set, useForm } from 'react-hook-form';
import { message } from 'antd';
import applicantsService from '../../../../Services/applicantsService';
// import jobVacancyJson from '../../../../Data/jobVacancy.json';
// eslint-disable-next-line no-unused-vars
import RegistrationFail from '../../Components/ConfirmationSlip/RegistrationFail/RegistrationFail';
import { Link, useNavigate } from 'react-router-dom';
import userService from '../../../../Services/userService';
import noteService from '../../../../Services/noticeboard';
import ManagedRoutes from '../../../../Components/RoutesAccessControl/manageRoutes';
import { useDispatch, useSelector } from 'react-redux';
import PrivacyPolicyContent from '../Faq/dtt';
import axios from 'axios';
import toast from 'react-hot-toast';
import bucketService from '../../../../Services/bucketService';
import { useVacancy } from '../../../../Hooks/getVacancy';

interface PropType {
  nin: any;
  formData: any;
  examNo: string;
  email: string;
  phone: string;
  candidateRole: string;
  vacancyField: string;
  vacancies: string;
  metadata: {
    createdAt: number;
    dbRowId: number;
    expiredAt: number;
    hasCompletedAdmission: boolean;
    hasSaveToDB: boolean;
    isQualified: boolean;
    isQualifiedForNextWorkflow: boolean;
    pDisqualify: boolean;
    pipeline: string[];
  };
  dataset: unknown;
}

const StartApplcation = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<PropType>();
  const candidateRoleKey = watch('candidateRole');
  const vacancyField = watch('vacancyField');
  // console.log('candidateRoleKey', candidateRoleKey);

  const [loading, setLoading] = useState(false);
  // const [loadingRRR, setLoadingRRR] = useState(false);
  const [alreadyRegistered] = useState(false);
  const [hideModal, setHideModal] = useState(false);
  const [resData, setResData] = useState<any>(); // eslint-disable-next-line no-unused-vars
  const [boxErrorMessage, setBoxErrorMessage] = useState<string>('');
  // eslint-disable-next-line no-unused-vars
  const [boxSuccessMessage, setBoxSuccessMessage] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [ninValidated, setNinValidated] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [nimcData, setNimcData] = useState<any>();
  const [, setFormData] = useState({ nin: '' });
  const [ninsetter, setNinsetter] = useState(0)
  // eslint-disable-next-line no-unused-vars
  const [rrrData, setRRRData] = useState<any>();

  const [dateM, setDateM] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [response, setResponse] = useState<any>();
  // const [, setRrrDataRetrive] = useState<any>();
  // eslint-disable-next-line no-unused-vars
  const navigation = useNavigate();
  // const navigate = useNavigation();
  // const dataset = {
  //   nin: ninValidated,
  //   nimcData,
  //   rrrData,
  // }
  const { jobVacancyJsonz, category } = useVacancy()
  const dispatch = useDispatch();
  const [admissionSettings, setAdmissionSettings] = useState<any>();
  const admissionSettingsService = async () => {
    try {
      const response: any = await bucketService.admissionSetting();

      // console.log('admission settings response', response);
      return response;
    } catch (error) {
      console.error('Error fetching admission settings:', error);
      return null;
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchSettings = async () => {
      const response = await admissionSettingsService();
      console.log('admission settings', response);
      if (!mounted) return;
      setAdmissionSettings(response);
      if (response !== undefined && response?.data?.datase !== undefined) {
        dispatch({
          type: 'SET_ADMISSION_SETTINGS',
          payload: response?.data?.dataset,
        });
      }
    };
    fetchSettings();
    return () => {
      mounted = false;
    };
  }, [dispatch]);

  const submit = async (data: any) => {
    const candidateRole: any = category[
      data.candidateRole as keyof typeof jobVacancyJsonz.dataset.category
    ] as any;
    // console.log('data', candidateRole)
    setLoading(true);
    setFormData({ ...data, candidateRole });
    await applicantsService
      .index({ ...data, candidateRole })
      .then((response) => {
        // console.log('RETURNED DATA', response);
        const responseData = response.data;
        setResponse(responseData.metadata);
        processNinData(responseData);
        setResData(responseData);
        // console.log('see', responseData.dataset);
        setBoxSuccessMessage(data);
        // console.log("ENCOUTER success", responseData);

        setLoading(false);

        // localStorage.setItem("pol", JSON.stringify(data))
      })
      .catch((error) => {
        setLoading(false);

        // console.log("ENCOUTER ERROR", error?.message);

        if (error?.response?.data?.display === 'html') {
          setBoxErrorMessage(error?.response?.data?.message);
        } else {
          throwError(
            error?.response?.data?.message || 'NIN validation failed!'
          );
        }
      });
  };

  const throwError = (
    mess: string = 'There was an error submitting application!'
  ) => {
    message.error({
      content: mess,
      style: {
        zIndex: '200000',
      },
    });
  };
  const [show, setShow] = useState<any>();

  const MenuController = async () => {
    await userService.getMenuCommand().then((response) => {
      const res = response?.data;
      // console.log("RRR", res)
      setShow(res);
    });
  };

  useEffect(() => {
    const commands = localStorage.getItem('MENU_COMMAND');
    if (commands !== null) {
      const { data } = JSON.parse(commands);
      setShow(data);
      // console.log('CachedData')
    } else {
      MenuController();
    }
  }, []);
  // useEffect(() => {
  // console.log('HEAD', resData)
  // }, [resData])
  const processNinData = useCallback(
    async (data: { [s: string]: unknown } | ArrayLike<unknown>) => {
      // if (metadata && metadata.pipeline.includes('NIMC')) {
      //   console.log('NIMC is included in the pipeline');
      // }

      if (data && Object.entries(data).length === 0) {
        setNimcData(null);
        setNinValidated(false);
      } else {
        setNimcData(data);

        if (data) {
          setNinValidated(true);
          // console.log('data', data);
          navigation('/verified-application', { state: data });
          // console.log('some', response?.isQualified);
        } else {
          setNinValidated(false);
          const rejectionReasons = response.registrationPipelineMessage
            ?.map((err: any) => err.message)
            .join('; ');
          // console.log('reject', rejectionReasons)
          navigation(
            `/rejection-slip?reasons=${encodeURIComponent(rejectionReasons)}`
          );
        }
      }
    },
    [ninValidated, setNinValidated, setNimcData]
  );

  const location = {
    pathname: '/verified-application',
    state: {
      resData: { resData },
    },
  };
  // console.log('location', location);
  // eslint-disable-next-line no-unused-vars
  // const [noticeData, setNoticeData] = useState<any>();
  const [formState, setFormState] = useState<number>(0);
  // const fetchNotice = async () => {
  //   await noteService.fetchNote().then(
  //     (res) => {
  //       // console.log("fetchNotice", res)
  //       setNoticeData(res?.data);
  //     },
  //     (error) => {
  //       console.log('fetchNotice error', error);
  //     }
  //   );
  // };
  // console.log('HELLO WORLD')
  const resume = async () => {
    try {
      setLoading(true);
      const data = {
        nin: ninsetter
      }
      const response = await applicantsService.resume(data)
      console.log(response.data)
      if (response.data.status === 301) {
        console.log(response.data.redirect)
        navigation(response.data.redirect)
        return
      }
      if (response) {
        // setFormData({ ...response.data.dataset.formData });
        const data = response.data;
        // setResponse(responseData.metadata);
        // processNinData(responseData);
        // setResData(responseData);
        // // console.log('see', responseData.dataset);
        // setBoxSuccessMessage(data);
        setNinValidated(true);
        // console.log('data', data);
        navigation('/verified-application', { state: data });

        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false)
      // toast.error('Unable to resume application process; try again later or kindly contact support')
      if (error?.response?.data?.display === 'html') {
        setBoxErrorMessage(error?.response?.data?.message);
      } else {
        throwError(
          error?.response?.data?.message || 'Unable to resume application process; try again later or kindly contact support'
        );
      }
    }
  }
  useEffect(() => {
    const isSessionActive = new Date(admissionSettings?.data?.dataset?.endDate) <= new Date()
    setDateM(isSessionActive)
    setHideModal(!isSessionActive)
  })
  // const dateM =
  // console.log('dateM', dateM, new Date(admissionSettings?.data?.dataset?.endDate), new Date())
  return (
    <Fragment>
      <div className='main-app'>
        {(!dateM && hideModal) && (
          <div className='overlay-instructions'>
            <div className='instruction-card  '>
              <div className='fw-bold  d-flex justify-content-end'>
                {' '}
                <svg
                  onClick={() => setHideModal(false)}
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  fill='currentColor'
                  type='button'
                  style={{ color: 'black' }}
                  className='bi bi-x-circle-fill text-black bg-black'
                  viewBox='0 0 16 16'
                >
                  <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z' />
                </svg>
              </div>
              <PrivacyPolicyContent />
              <div className='d-flex justify-content-center'>
                <button
                  className='btn btn-light swapper'
                  onClick={() => setHideModal(false)}
                >
                  <span>Thank you</span>
                  <span>Click to close</span>
                </button>
              </div>
            </div>
          </div>
        )}
        <RegisterHeader />
        {/* {
          show?.registrationForm.switch === 0 && */}
        <div className='split-container'>
          {/* LEFT SIDEBAR (Stepper) */}
          <div className='split-sidebar'>
            <div className='sidebar-overlay'></div>
            <div className='sidebar-content'>
              {/* The Vertical Stepper */}
              {/* <div className="stepper">
              <div className="step-item active">
                <div className="step-circle">1</div>
                <div className="step-line"></div>
              </div>
              <div className="step-item">
                <div className="step-circle">2</div>
                <div className="step-line"></div>
              </div>
              <div className="step-item">
                <div className="step-circle">3</div> */}
              {/* No line for last item */}
              {/* </div>
            </div> */}
            </div>
          </div>
          <main role='main' className=' split-main'>
            {boxErrorMessage && (
              <RegistrationFail
                message={boxErrorMessage}
                clearErrorBox={() => setBoxErrorMessage('')}
              />
            )}
            {!boxErrorMessage && (
              <div className=' pt-5'>
                <div>
                  <section
                    className={` border-0 rounded${
                      boxErrorMessage ? ' d-none' : ''
                    }`}
                  >

                   { !dateM && <div className='px-lg-5'>
                      <div className=''>
                        <div className='py-2 fw-bold rounded-4 pt-5'>
                          <span className=' text-black border-bottom border-5 border-success fst-1 stepfont'>
                            <b> Step {1}</b>
                          </span>
                        </div>
                      </div>
                    </div>}
                  </section>
                   {dateM && (
                    <>
                      <div className="admissionClosed">
                        <div className="admissionClosed__container">
                          <div className="admissionClosed__iconWrapper">
                            <svg className="admissionClosed__iconLarge" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                            </svg>
                          </div>
                          <div className="admissionClosed__content">
                            <h2 className="admissionClosed__title">College Call-Up Notice</h2>
                            <p className="admissionClosed__message">
                              The Police Service Commission (PSC) has released the names of successful applicants for the recruitment of 50,000 into the Nigeria Police Force as Police Constables.
                            </p>
                            <p className="admissionClosed__submessage">
                              The release follows the successful conclusion of a comprehensive, inclusive, equitable and transparent recruitment exercise conducted in collaboration with major stakeholders including the Nigeria Police Force, Federal Character Commission, Ministry of Police Affairs, States Career and Counseling Departments and the Police Community Relations Committee.
                            </p>
                            <p className="admissionClosed__submessage">
                              Successful candidates will also receive email and SMS notifications on the email addresses and phone numbers they provided during the initial application.
                            </p>
                            <p className="admissionClosed__submessage">
                              The successful candidates are expected to report to their designated Police Training Institutions on dates and times to be communicated in due course for medical examination and documentation. Candidates who fail to report within the stipulated time will be considered to have declined the offer. In addition, those who fail the medical examination that would be conducted by the Police Medical Team on resumption of training will be declared unfit and shall be required to leave the training.
                            </p>
                            <div style={{ textAlign: 'left', background: '#f4f7fb', borderRadius: 6, padding: '12px 18px', margin: '12px 0', fontSize: 14 }}>
                              <strong style={{ display: 'block', marginBottom: 8 }}>Required items on resumption:</strong>
                              <ul style={{ margin: 0, paddingLeft: 20 }}>
                                <li>Call-up slip</li>
                                <li>NIN slip</li>
                                <li>BVN slip</li>
                                <li>Original and photocopies of their certificates and other required documents</li>
                                <li><strong>Dress Code:</strong> White shorts, white T-shirt and white canvas</li>
                              </ul>
                            </div>
                          </div>
                          <p style={{ color: '#c00', fontWeight: 900, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 0 }}>
                            Note: THIS SLIP MUST BE PRINTED AND PRESENTED IN COLOUR (NOT BLACK AND WHITE)
                          </p>
                          <div style={{ height: 16 }} />
                          <div className="admissionClosed__actions">
                            <a href='/college-slip' className="admissionClosed__btn admissionClosed__btn--primary">
                              <svg className="admissionClosed__btnIcon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                              </svg>
                              Print College Call-Up Slip
                            </a>
                            <a href="mailto:support@psc.gov.ng" className="admissionClosed__btn admissionClosed__btn--secondary">
                              Contact Support
                            </a>
                          </div>
                          <div className="admissionClosed__footer">
                            <p className="admissionClosed__footerText">
                              The recruitment process is <strong>entirely free</strong>. Report any suspicious activity or scam to{' '}
                              <a href="mailto:info@psc.gov.ng">info@psc.gov.ng</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                   )}
                  {!dateM && <form onSubmit={handleSubmit(submit)}>
                    <div className='row p-5 justify-content-center px-lg-5'>
                      <div className='form-group col-md-6 padleft px-lg-5 py-lg-5'>
                        <div className='row gap-2'>
                          <button
                            className={`btn ${formState === 1 ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                            disabled= {formState === 0}
                            onClick={() => setFormState(0)}
                          >
                            Start Application
                          </button>
                          <div className='border-left border-success mx-2'></div>
                          <button
                              className={`btn ${formState === 0 ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                            disabled= {formState === 1}
                            onClick={() => setFormState(1)}
                          >
                            Resume Application
                          </button>

                        </div>

                        {formState === 1 && <div>
                          <div className='text-start font-weight-bold text-dark p-2'>
                            <i className='fa fa-default text-start'></i>Please,
                            ensure you have a pending/unsubmitted application before using this service.
                          </div>
                          <div>
                            <div className='form-group'>
                              <input
                                type='number' // 1. Change type to text
                                inputMode='numeric' // 2. Ensures number pad appears on mobile
                                {...register('nin', {
                                  required: 'nin cannot be empty',
                                  maxLength: {
                                    value: 11,
                                    message: "NIN can't be more than 11 digits",
                                  },
                                  minLength: {
                                    value: 11,
                                    message: "NIN can't be less than 11 digits",
                                  },
                                  pattern: {
                                    value: /^[0-9]+$/,
                                    message: 'NIN must contain only numbers',
                                  },
                                  validate: {
                                    // 1. Your custom check for identical digits (e.g., 11111111111)
                                    notIdentical: (value) => {
                                      // Regex: Capture first digit (\d), then check if it repeats (\1) 10 times
                                      if (/^(\d)\1{10}$/.test(value)) {
                                        return 'Invalid NIN: All digits cannot be identical';
                                      }
                                      return true;
                                    },
                                    // 2. Extra check to ensure no letters crept in (redundant if pattern is used, but safe)
                                    isNumber: (value) =>
                                      !isNaN(Number(value)) ||
                                      'NIN must be a valid number',
                                  },
                                  onChange: (e) => {
                                    const value = e.target.value;
                                    setNinsetter(value)
                                    if (value.length > 11) {
                                      e.target.value = value.slice(0, 11);
                                    }
                                  },
                                })}
                                className={`custom-form-control form-control`}
                                id='nin'
                                placeholder='Please provide a NIN'
                              />
                              {!ninValidated && (
                                <small className='text-dark'>
                                  Please provide a valid NIN
                                </small>
                              )}
                            </div>
                          </div>
                          <div>
                            <button className='btn btn-danger w-100' type='button' onClick={() => { resume() }}>{loading && (
                              <span
                                className='spinner-border spinner-border-sm'
                              ></span>
                            )}Resume application</button>
                          </div>
                        </div>}
                        {formState === 0 && <div>
                          <div className='text-start font-weight-bold text-dark p-2'>
                            <i className='fa fa-default text-start'></i>Please
                            provide the required information to continue.
                          </div>
                          <br />

                          <div className='form-group'>
                            <input
                              type='number' // 1. Change type to text
                              inputMode='numeric' // 2. Ensures number pad appears on mobile
                              {...register('nin', {
                                required: 'nin cannot be empty',
                                maxLength: {
                                  value: 11,
                                  message: "NIN can't be more than 11 digits",
                                },
                                minLength: {
                                  value: 11,
                                  message: "NIN can't be less than 11 digits",
                                },
                                pattern: {
                                  value: /^[0-9]+$/,
                                  message: 'NIN must contain only numbers',
                                },
                                validate: {
                                  // 1. Your custom check for identical digits (e.g., 11111111111)
                                  notIdentical: (value) => {
                                    // Regex: Capture first digit (\d), then check if it repeats (\1) 10 times
                                    if (/^(\d)\1{10}$/.test(value)) {
                                      return 'Invalid NIN: All digits cannot be identical';
                                    }
                                    return true;
                                  },
                                  // 2. Extra check to ensure no letters crept in (redundant if pattern is used, but safe)
                                  isNumber: (value) =>
                                    !isNaN(Number(value)) ||
                                    'NIN must be a valid number',
                                },
                                onChange: (e) => {
                                  const value = e.target.value;
                                  if (value.length > 11) {
                                    e.target.value = value.slice(0, 11);
                                  }
                                },
                              })}
                              className={`custom-form-control form-control`}
                              id='nin'
                              placeholder='NIN No'
                            />
                            {!ninValidated && (
                              <small className='text-dark'>
                                Please provide a valid NIN
                              </small>
                            )}
                          </div>
                          <div className='form-group'></div>
                          <div className='form-group'>
                            <input
                              type='email'
                              {...register('email', {
                                required: 'Email cannot be empty',
                              })}
                              className={`custom-form-control form-control `}
                              id='niemailn'
                              placeholder='Your email address'
                            />
                            {errors.email && (
                              <div className='text-danger'>
                                {errors.email.message}
                              </div>
                            )}
                          </div>
                          <div className='form-group'>
                            <input
                              type='number'
                              inputMode='numeric'
                              {...register('phone', {
                                required: 'Phone cannot be empty',
                                maxLength: {
                                  value: 11,
                                  message: 'Phone number must be 11 digits',
                                },
                                onChange: (e) => {
                                  const value = e.target.value;
                                  if (value.length > 11) {
                                    e.target.value = value.slice(0, 11);
                                  }
                                },
                              })}
                              className={`custom-form-control form-control `}
                              id='phone'
                              placeholder='Your phone no e.g 08034008900 (without country code)'
                            />
                            {errors.phone && (
                              <div className='text-danger'>
                                {errors.phone.message}
                              </div>
                            )}
                          </div>
                          <div className={'mb-3'}>
                            <select
                              className={`custom-form-control form-control`}
                              {...register('candidateRole')}
                            >
                              <option value={''}>
                                -- Please choose job title --
                              </option>
                              {jobVacancyJsonz !== undefined &&
                                category !== undefined &&
                                Object.entries(category).map(
                                  ([key, value]: [string, any]) => {
                                    // console.log('jobVacancyJson-v', key);
                                    return (
                                      <option key={key} value={key}>
                                        {value}
                                      </option>
                                    );
                                  }
                                )}
                            </select>
                            {errors.candidateRole && (
                              <div className='text-danger'>
                                {errors.candidateRole.message}
                              </div>
                            )}
                          </div>
                          {jobVacancyJsonz !== undefined &&
                            Object.keys(
                              jobVacancyJsonz.dataset.vacancyField
                            ).includes(candidateRoleKey) && (
                              <div className={'mb-3'}>
                                <select
                                  className={`custom-form-control form-control `}
                                  {...register('vacancyField')}
                                >
                                  <option value={''}>
                                    -- Please select from vacancies --
                                  </option>
                                  {(
                                    (
                                      jobVacancyJsonz.dataset
                                        .vacancyField as Record<
                                        string,
                                        string[]
                                      >
                                    )[candidateRoleKey as string] || []
                                  ).map((value, idx) => (
                                    <option key={idx} value={value}>
                                      {value}
                                    </option>
                                  ))}
                                </select>
                                {errors.candidateRole && (
                                  <div className='text-danger'>
                                    {errors.candidateRole.message}
                                  </div>
                                )}
                              </div>
                          )}
                          {jobVacancyJsonz !== undefined &&
                            Object.keys(
                              jobVacancyJsonz.dataset.vacancies
                            ).includes(candidateRoleKey) &&
                            vacancyField && (
                              <div className={'mb-3'}>
                                <select
                                  className={`custom-form-control form-control `}
                                  {...register('vacancies')}
                                >
                                  <option value={''}>
                                    -- Please select from vacancies --
                                  </option>
                                  {jobVacancyJsonz !== undefined &&
                                    Object.entries(
                                      jobVacancyJsonz.dataset.vacancies
                                    )
                                      .filter(
                                        ([groupName]) =>
                                          groupName === candidateRoleKey
                                      )
                                      .map(
                                        (
                                          [groupName, groupArray]: any,
                                          groupIdx: number
                                        ) =>
                                          groupArray.map(
                                            (
                                              categoryObj: any,
                                              catIdx: number
                                            ) => {
                                              const categoryName =
                                                Object.keys(categoryObj)[0];
                                              // console.log(
                                              //   'categoryName',
                                              //   groupName
                                              // );
                                              const roles =
                                                categoryObj[vacancyField];
                                              // console.log('roles', roles);

                                              return (
                                                roles !== undefined &&
                                                roles.map(
                                                  (
                                                    role: string,
                                                    roleIdx: number
                                                  ) => (
                                                    <option
                                                      key={`${groupIdx}-${catIdx}-${roleIdx}`}
                                                      value={role}
                                                    >
                                                      {role}
                                                    </option>
                                                  )
                                                )
                                              );
                                            }
                                          )
                                      )}
                                </select>
                                {errors.candidateRole && (
                                  <div className='text-danger'>
                                    {errors.candidateRole.message}
                                  </div>
                                )}
                              </div>
                          )}
                          <div className=''>
                            <small className='text-dark'>
                              Please choose carefully, upon verification, you
                              will not be allowed to change the option
                            </small>
                          </div>
                          <div className='text-center'>
                            {/* <Link to='/verified-application'> */}{' '}
                            <button
                              className={
                                ninValidated
                                  ? `btn btn-success font-weight-bold w-100`
                                  : `btn verify-button text-white font-weight-bold w-100`
                              }
                              type='submit'
                            >
                              {ninValidated && (
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='16'
                                  height='16'
                                  fill='currentColor'
                                  className='bi bi-check-circle-fill'
                                  viewBox='0 0 16 16'
                                >
                                  <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' />
                                </svg>
                              )}
                              {ninValidated ? ' Verified' : 'Verify'}
                            </button>
                            {/* </Link> */}
                            {loading && (
                              <div
                                style={{ marginTop: 10 }}
                                className='spinner-border spinner-border-sm'
                              ></div>
                            )}
                          </div>

                          {alreadyRegistered && (
                            <small className='error-value'>
                              Applicant already registered. Redirecting to pint
                              slip...
                            </small>
                          )}
                        </div>}
                      </div>
                    </div>
                    <div className='w-100 text-center'>
                      {/* <div className='text-center'>
                    <p className='font-weight-bold text-dark p-2'>
                      Application into Nigeria Police Force (NPF) requires
                      National Identification Number (NIN), <br />
                      by providing the NIN, you have given Nigeria Police Force
                      the right to get your Bio data <br />
                      i.e. Your profile will be validated on this page before
                      you can proceed to the application form. <br />
                      Thank you.
                    </p>
                  </div> */}
                      {response && (
                        <div>
                          {response.hasCompletedAdmission
                            ? (
                            <div>
                              {!response.isQualified
                                ? (
                                <div className='alert alert-danger'>
                                  {response.registrationPipelineMessage}
                                </div>
                                  )
                                : (
                                <button>Slip</button>
                                  )}
                            </div>
                              )
                            : (
                            <div className='alert alert-success'>
                              <button className={'btn btn-success'}>
                                PROCEED TO APPLICATION FORM
                              </button>
                            </div>
                              )}
                        </div>
                      )}
                    </div>
                  </form>}
                </div>
                {!dateM && <div className='hta-container'>
                  <h3 className='hta-title'>How to Apply</h3>
                  <div className='hta-grid'>
                    <div className='hta-card'>
                      <div className='hta-step-number'>1</div>
                      <div className='hta-text'>
                        Kindly obtain your National Identification Number (NIN)
                        from National Identity Management Commission (NIMC).
                      </div>
                    </div>
                    <div className='hta-card'>
                      <div className='hta-step-number'>2</div>
                      <div className='hta-text'>
                        Input the NIN and other details in provided fields below
                        to obtain your bio-data information.
                      </div>
                    </div>
                    <div className='hta-card'>
                      <div className='hta-step-number'>3</div>
                      <div className='hta-text'>
                        Upon validation, you will be allowed to proceed into the
                        Application Form
                        <li> Fill the Application</li>
                        <li> Upload Document </li>
                        <li> Submit Application </li>
                        <li> Redirect to Preview </li>
                      </div>
                    </div>
                    <div className='hta-card'>
                      <div className='hta-step-number'>4</div>
                      <div className='hta-text'>
                        On Preview Page,
                        <p>
                          kindly click on Final Submission button, you will be
                          directed to a preview page where you must review your
                          profile before final submission.{' '}
                        </p>
                        Please note that final submission is required. Any
                        unsubmitted application on the preview page will be
                        considered incomplete and invalid.
                      </div>
                    </div>
                    <div className='hta-card'>
                      <div className='hta-step-number'>5</div>
                      <div className='hta-text'>
                        Application Submission Slip,
                        <p>kindly use the Print Submission Slip. </p>
                        <li>
                          {' '}
                          NOTE: Candidate who has submitted their application
                          should proceed to printing of submission slip only{' '}
                        </li>
                      </div>
                    </div>
                  </div>
                </div>}
              </div>
            )}
          </main>
        </div>
        {/* <>
            <div className='container pt-4'>
              <h3 className="text-center"><strong><u>2022&nbsp;POLICE CONSTABLE RECRUITMENT</u></strong></h3>
              <ol type='1'>
                <li className="ql-align-justify">The Nigeria Police Recruitment Board&nbsp;invites all candidates,&nbsp;who successfully
                  completed the online registration for recruitment into the Nigeria Police Force as police constable, for
                  Automated Physical/Credentials&nbsp;Screening Exercise, is scheduled to hold from Monday, January 8, to Monday,
                  January 29,&nbsp;2024, 0700hrs daily&nbsp;at the&nbsp;State Police Headquarters in their respective State of
                  origin nationwide. Kindly visit <a href="https://apply.policerecruitment.gov.ng/" rel="noopener noreferrer"
                    target="_blank" style={{ color: "rgb(0, 0, 255);" }}><u>https://apply.policerecruitment.gov.ng/</u></a>&nbsp;to
                  the recruitment portal print out their invitation slip from 25<sup>th</sup>&nbsp;December, 2023.</li>
                <li className="ql-align-justify">Consequently, all applicants are to appear at the&nbsp;screening&nbsp;centre in
                  their&nbsp;clean white T-shirt and short with the following <strong>mandatory </strong>basic screening
                  requirements, neatly arranged in two white flat files with a recent passport photographs attached:</li>
                <ol type='i'>
                  <li className="ql-align-justify ql-indent-1"><strong>&nbsp;Evidence of physical/mental fitness from a government
                    recognized Medical Hospital</strong></li>
                  <li className="ql-align-justify ql-indent-1"><strong>&nbsp;Evidence of Good character from Village/District Head of the
                    applicant.</strong></li>
                  <li className="ql-align-justify ql-indent-1"><strong>&nbsp;Certificate of Origin duly signed by the Local Government
                    Chairman or Secretary</strong></li>
                  <li className="ql-align-justify ql-indent-1"><strong>&nbsp;National Identity Number (NIN)&nbsp;- Slip Print
                    -out</strong></li>
                  <li className="ql-align-justify ql-indent-1"><strong>Original and duplicate copies of credentials – O’ Level Result(s),
                    Birth Certificate/Declaration of Age</strong></li>
                  <li className="ql-align-justify ql-indent-1"><strong>Print-out of application form</strong></li>
                  <li className="ql-align-justify ql-indent-1"><strong>Duly completed Guarantor’s form</strong></li>
                  <li className="ql-align-justify ql-indent-1"><strong>Invitation slip</strong></li>
                </ol>
                <li className="ql-align-justify">Any candidate who fails to present the items (i -viii) mentioned in Paragraph 2 above,
                  will not be considered for screening.</li>
                <li className="ql-align-justify">Applicants are equally advised to pay attention to their scheduled date and time, other
                  details&nbsp;and specific guidelines on the screening exercise.</li>
              </ol>
              <div className='text-center'>
              <p className="ql-align-center"><strong>Signed</strong></p>
              <p className="ql-align-center"><strong>Police Recruitment&nbsp;Board </strong></p>
              <p className="ql-align-justify"><br /></p>
              </div>
            </div>
          </> */}
        <></>
        <Footer />
      </div>
    </Fragment>
  );
};
export default StartApplcation;
// (noticeData !== 0 && noticeData.map((notice: any, index: number) => {
//               return <div className="" key={index}>
//               <div className="row h-100 justify-content-center">
//                 <div className="col-md-12 my-auto">
//                   <div className="card py-0 shadow-0 fw-bold rounded-3">
//                     <div className='card-header text-center'></div>
//                     <div className="card-body text-start homedisablecard">
//                       <div className='container pt-5'>
//                         <h2 className="text-center border-bottom text-white mt-3">{notice?.subject}</h2>
//                         <div dangerouslySetInnerHTML={{ __html: notice?.body }}></div>
//                         <div className='text-center mt-3 pb-5'>
//                           <Link to={notice?.button_link}><button className='btn btn-danger w-50'><span className='fw-bold'>{notice?.button_label}</span></button></Link>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             }))
